import {
  Avatar,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Text,
} from '@fluentui/react-components';
import {
  SignOut24Regular,
  WeatherMoon24Regular,
  WeatherSunny24Regular,
} from '@fluentui/react-icons';
import React from 'react';

import { useAppContext } from '../../context/AppContext.js';
import { useAuth } from '../../hooks/useAuth/useAuth.js';
import { getGraphProfilePhoto } from '../../services/profilePhotosService.js';

import { useUserMenuStyles } from './user-menu.style';

export interface UserMenuProps {
  displayName: string;
  onSignOut: () => void;
}

export const UserMenu: React.FC<UserMenuProps> = ({
  displayName,
  onSignOut,
}) => {
  const styles = useUserMenuStyles();
  const { colorScheme, toggleColorScheme } = useAppContext();
  const { getGraphToken } = useAuth();
  const [photoUrl, setPhotoUrl] = React.useState<string>();
  const isDark = colorScheme === 'dark';

  React.useEffect(() => {
    let cancelled = false;
    setPhotoUrl(undefined);

    void getGraphProfilePhoto(getGraphToken)
      .then((url) => {
        if (!cancelled) setPhotoUrl(url);
      })
      .catch((error: unknown) => {
        console.warn('Failed to load the current user profile photo.', error);
      });

    return () => {
      cancelled = true;
    };
  }, [displayName, getGraphToken]);

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <div className={styles.trigger}>
          <Text className={styles.displayName}>{displayName}</Text>
          <Avatar
            name={displayName}
            color="colorful"
            image={photoUrl ? { src: photoUrl } : undefined}
          />
        </div>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem
            icon={isDark ? <WeatherSunny24Regular /> : <WeatherMoon24Regular />}
            onClick={toggleColorScheme}
          >
            {isDark ? 'Light mode' : 'Dark mode'}
          </MenuItem>
          <MenuItem icon={<SignOut24Regular />} onClick={onSignOut}>
            Sign out
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
